import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654e3a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerFiltersDash = _resolveComponent("headerFiltersDash")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_headerFiltersDash, {
      filters: _ctx.filters,
      title: 'Ordens em recebimento',
      "show-private-brands": true,
      onUpdateParams: _ctx.UpdateParams,
      onApplySearchParams: _ctx.applySearchParams
    }, null, 8, ["filters", "onUpdateParams", "onApplySearchParams"])
  ]))
}